import AxiosInstance from './AxiosInstance';

export const getLoggedInUserApi = (userData) =>
  AxiosInstance.post('users/login', userData);
